import Welcome from '../../assets/images/icon_welcome.png'
import Compliance from '../../assets/images/icon_compliance.png'
import Overview from '../../assets/images/icon_overview.png'
import Products from '../../assets/images/icon_products.png'
import Customers from '../../assets/images/icon_customers.png'
import Orders from '../../assets/images/icon_orders.png'
import Wallets from '../../assets/images/icon_wallet.png'
import Transactions from '../../assets/images/icon_transactions.png'

export const DefaultLinks = [
	{
		id: 101,
		img: Welcome,
		alt: 'Welcome',
		text: 'Welcome',
	},
	{
		id: 102,
		img: Compliance,
		alt: 'Compliance',
		text: 'Compliance',
	},
	{
		id: 103,
		img: Overview,
		alt: 'Overview',
		text: 'Overview',
	},
]

export const BusinessLinks = [
	{
		id: 104,
		img: Products,
		alt: 'Products',
		text: 'Products',
	},
	{
		id: 105,
		img: Customers,
		alt: 'Customers',
		text: 'Customers',
	},
	{
		id: 106,
		img: Orders,
		alt: 'Orders',
		text: 'Orders',
	},
]
export const PaymentLinks = [
	{
		id: 107,
		img: Wallets,
		alt: 'Wallets',
		text: 'Wallets',
	},
	{
		id: 108,
		img: Transactions,
		alt: 'Transactions',
		text: 'Transactions',
	},
]
